import type * as React from 'react';
const SvgIcoWon = (props: React.SVGProps<SVGSVGElement>) => (
  <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" width="1em" height="1em" {...props}>
    <g stroke="currentColor">
      <path d="M19.13 17.141a2.958 2.958 0 0 0 1.593-4.183l-2.527-4.691a1 1 0 0 0-1.222-.466l-2.293.833a1 1 0 0 0-.634 1.161l1.186 5.221a2.96 2.96 0 0 0 3.896 2.125M22 19.77 18.63 21m-3.94-8.39h5.84m-1.4 4.53 1.18 3.25M4.87 17.141a2.958 2.958 0 0 1-1.593-4.183l2.527-4.691a1 1 0 0 1 1.222-.466l2.293.833a1 1 0 0 1 .634 1.161l-1.186 5.221a2.96 2.96 0 0 1-3.896 2.125M2 19.77 5.37 21m3.94-8.39H3.46m1.41 4.53-1.18 3.25M15 5l1-1M9 5 8 4m4 0V3" />
    </g>
  </svg>
);
export default SvgIcoWon;
